module.exports = __webpack_public_path__ + "static/media/illustration-home-privacy.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/illustrations/illustration-home-privacy.svg
// module id = 537
// module chunks = 0